import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class EmailIdConflictModal extends PureComponent {
  render() {
    const { emailId, onClose } = this.props;
    return (
      <div>
        <Dialog
          open={Boolean(emailId)}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{''}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {`Please Authenticate using email Id : ${emailId}`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} color="primary" className="confirm-btn">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
